import firebase from "config/firebase";
export const getAllNotifications = (lastDoc = null, onSuccess = () => {}) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_NOTIFICATIONS_PENDING" });

    try {
      const notificationsCollectionRef = firebase
        .firestore()
        .collection("admin_notifiaction");
      const notificationsLimit = 5;

      let q = notificationsCollectionRef
        .orderBy("createdAt", "desc")
        .limit(notificationsLimit);

      if (lastDoc) {
        q = q.startAfter(lastDoc);
      }

      const querySnapshot = await q.get();

      // const unsubscribe = q.onSnapshot((querySnapshot) => {
      const notifications = [];
      let lastVisible = lastDoc;

      querySnapshot.forEach((doc) => {
        notifications.push({ id: doc.id, ...doc.data() });
        lastVisible = doc;
      });

      const hasMoreNotifications = querySnapshot.size >= notificationsLimit;

      dispatch({
        type: lastDoc
          ? "FETCH_NOTIFICATIONS_LOAD_MORE_SUCCESS"
          : "FETCH_NOTIFICATIONS_SUCCESS",
        payload: {
          notifications,
          lastDoc: lastVisible,
          hasMoreNotifications,
        },
      });

      onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error(error.message);
      dispatch({
        type: "FETCH_NOTIFICATIONS_REJECTED",
        error: error.message,
      });
      onSuccess();
    }
  };
};

export const getNotificationsByStatus = (
  status,
  lastDoc = null,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCH_NOTIFICATIONS_BY_STATUS_PENDING",
      payload: status,
    });

    try {
      const notificationsCollectionRef = firebase
        .firestore()
        .collection("admin_notifiaction");
      const notificationsLimit = 5;

      let q = notificationsCollectionRef
        .where("status", "==", status)
        .orderBy("createdAt", "desc")
        .limit(notificationsLimit);

      if (lastDoc) {
        q = q.startAfter(lastDoc);
      }

      const querySnapshot = await q.get();

      // const unsubscribe = q.onSnapshot((querySnapshot) => {
      const notifications = [];
      let lastVisible = lastDoc;

      querySnapshot.forEach((doc) => {
        notifications.push({ id: doc.id, ...doc.data() });
        lastVisible = doc;
      });

      const hasMoreNotifications = querySnapshot.size >= notificationsLimit;

      dispatch({
        type: lastDoc
          ? "FETCH_NOTIFICATIONS_BY_STATUS_LOAD_MORE_SUCCESS"
          : "FETCH_NOTIFICATIONS_BY_STATUS_SUCCESS",
        payload: {
          status,
          notifications,
          lastDoc: lastVisible,
          hasMoreNotifications,
        },
      });

      onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error(error.message);
      dispatch({
        type: "FETCH_NOTIFICATIONS_BY_STATUS_REJECTED",
        error: error.message,
      });
      onSuccess();
    }
  };
};

export const getUnreadNotificationsCount = () => {
  return (dispatch) => {
    dispatch({ type: "FETCH_UNREAD_NOTIFICATIONS_COUNT_PENDING" });

    const notificationsCollectionRef = firebase
      .firestore()
      .collection("admin_notifiaction");

    return notificationsCollectionRef.where("status", "==", false).onSnapshot(
      (querySnapshot) => {
        const unreadNotificationsCount = querySnapshot.size;

        dispatch({
          type: "FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS",
          payload: unreadNotificationsCount,
        });
      },
      (error) => {
        console.error(error.message);
        dispatch({
          type: "FETCH_UNREAD_NOTIFICATIONS_COUNT_REJECTED",
          error: error.message,
        });
      }
    );
  };
};

export const updateNotification = (id, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("admin_notifiaction")
        .doc(id)
        .update({ status: true });
      onSuccess();
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };
};

export const updateUserDeviceToken = (token, userId) => {
  return async (dispatch) => {
    try {
      await firebase.firestore().collection("users").doc(userId).update({
        fcmToken: token,
      });

      const updatedDoc = await firebase
        .firestore()
        .collection("users")
        .doc(userId)
        .get();

      const updatedUser = { id: updatedDoc.id, ...updatedDoc.data() };

      dispatch({
        type: "UPDATE_USER_DEVICE_TOKEN",
        payload: updatedUser,
      });
    } catch (error) {
      console.error("🔥 Error updating device token:", error);
    }
  };
};
